import PropTypes from "prop-types";

/**
 * Region-aware payment method chips — styled text spans, no new npm dependency.
 * Renders the accepted payment methods for the given region in a clean, understated style.
 */

const METHODS_IN = [
  { label: "UPI", key: "upi" },
  { label: "GPay", key: "gpay" },
  { label: "PhonePe", key: "phonepe" },
  { label: "Cards", key: "cards-in" },
];

const METHODS_US = [
  { label: "Cards", key: "cards-us" },
  { label: "Apple Pay", key: "apple-pay" },
  { label: "Google Pay", key: "google-pay" },
];

const PaymentLogos = ({ region }) => {
  const methods = region === "IN" ? METHODS_IN : METHODS_US;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-[#52615f]">Accepted:</span>
      {methods.map(({ label, key }) => (
        <span
          key={key}
          className="rounded border border-[#dfe8e6] bg-white px-2 py-0.5 text-xs font-medium text-[#33413f]"
        >
          {label}
        </span>
      ))}
    </div>
  );
};

PaymentLogos.propTypes = {
  region: PropTypes.oneOf(["IN", "US"]).isRequired,
};

export default PaymentLogos;
